module.exports = __webpack_public_path__ + "img/how_to_print_edge_en.2d81d187.png";